exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mx-datepicker-popup {\n  z-index: 1060;\n}\n.mx-datepicker {\n  width: 100% !important;\n}\n.booking_property {\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n  display: flex;\n}\n.booking_property img {\n  height: 70px;\n}\n.booking_property .b_details {\n  padding-left: 25px;\n}\n.booking_property .b_details p {\n  margin-bottom: 5px;\n}\n.booking_property .b_details .prop_title {\n  font-weight: bold;\n  font-size: 14px;\n}\n.booking_property .b_details .prop_price {\n  font-weight: bold;\n}", ""]);

// exports
